module.exports = __webpack_public_path__ + "static/media/icon_localization_ramp.8ec57a1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_localization_ramp.svg
// module id = 331
// module chunks = 0